module.exports = __webpack_public_path__ + "static/media/in-the-office.8f8b8316.svg";